import {
    ApiShopperLandingPage,
    ApiShopperLandingPageLink,
    VLPVariant,
} from '@storefronts/common-types'
import Script from 'next/script'
import { Cart } from '../../types'
import { markVendorReady, runWhenReady } from './pixelRuntime'

export const BlotoutScript: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    if (!landingPage.integrations.blotoutId) return null

    return (
        <>
            <Script id="ms-blotout" strategy="afterInteractive">
                {`window.edgetag=window.edgetag||function(){(edgetag.stubs=edgetag.stubs||[]).push(arguments)};
                edgetag('init', {
                edgeURL: '${landingPage.integrations.blotoutId}',
                disableConsentCheck: true
                })`}
            </Script>
            <Script
                id="blotout"
                strategy="afterInteractive"
                src={`${landingPage.integrations.blotoutId}/load`}
                onReady={() => markVendorReady('blotout')}
            />
        </>
    )
}

export class BlotoutTrackker {
    static checkBlotout(): boolean {
        return window.hasOwnProperty('edgetag')
    }

    static trackPageView() {
        runWhenReady('blotout', () => {
            if (!BlotoutTrackker.checkBlotout()) return
            window.edgetag('tag', 'PageView')
        })
    }

    static trackProductView(
        link: ApiShopperLandingPageLink,
        variant: VLPVariant,
    ) {
        runWhenReady('blotout', () => {
            if (!BlotoutTrackker.checkBlotout()) return

            window.edgetag('tag', 'ViewContent', {
                currency: 'USD',
                value: variant.price.price / 100,
                contents: [
                    {
                        id: variant.shopifyId,
                        quantity: 1,
                        item_price: variant.price.price / 100,
                        title: variant.title,
                        category: '',
                        image: link.imageUrl,
                        url: window.location.href,
                    },
                ],
            })
        })
    }

    static trackAddToCart(cart: Cart) {
        runWhenReady('blotout', () => {
            if (!BlotoutTrackker.checkBlotout()) return

            const variant = cart.items[0].variant

            window.edgetag('tag', 'AddToCart', {
                currency: 'USD',
                value: variant.price.price / 100,
                contents: [
                    {
                        id: variant.link.shopifyId,
                        quantity: 1,
                        item_price: variant.price.price / 100,
                        title: variant.link.title,
                        image: variant.imageUrl,
                        url: window.location.href,
                    },
                ],
                checkoutUrl: cart.checkoutUrl,
            })
        })
    }
}
